<template>
  <div class="horizontal-menu">
    <ul class="menu-ul">
      <template v-for="item in menus">
        <li class="menu-item" :key="item.path" v-if="!item.hidden">
          <div v-if="item.children && !item.hideChildrenInMenu" class="menu-text">
            <span :class="['menu-title', isActive(item.path) && 'active']">
              <a-icon v-if="item.meta.icon" :type="item.meta.icon" />
              {{ item.meta.title }}</span
            >
            <menu-item class="menu-com" :menu="item"></menu-item>
            <a-icon type="down" class="icon-box" />
          </div>
          <span v-else :class="['menu-title', isActive(item.path) && 'active']" @click="$router.push(item.path)">
            <a-icon v-if="item.meta.icon" :type="item.meta.icon" />
            {{ item.meta.title }}</span
          >
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import MenuItem from './MenuItem.vue'
export default {
  components: {
    MenuItem,
  },
  props: {
    menus: {
      default: () => [],
    },
  },
  created() {},
  methods: {
    isActive(route) {
      let routelist = this.$route.path.split('/')
      let routeActivelist = route.split('/')
      return !routeActivelist.some((item, index) => {
        return routeActivelist[index] !== routelist[index]
      })
    },
  },
}
</script>

<style lang="less" scoped>
.horizontal-menu {
  flex: 1;
}
.menu-ul {
  display: flex;
  position: relative;
}
.menu-item {
  padding: 0 16px;
  min-width: 80px;
  line-height: 64px;
  position: relative;
}
.menu-title {
  color: #000000a6;
  font-family: 'PingFang SC';
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px;
  cursor: pointer;
}
.menu-title:hover {
  color: #165dff;
  font-family: 'PingFang SC';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}
.menu-com {
  display: none;
}
.menu-text:hover .menu-com {
  display: block;
}
.active {
  color: #165dff !important;
  font-family: 'PingFang SC';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
}
.menu-hove-ul {
  position: relative;
  .menu-title {
    position: absolute;
    bottom: 0;
    left: 0;
    background: #fff;
    height: 100px;
  }
}
.icon-box {
  font-size: 12px;
  color: #00000040;
  margin-left: 8px;
  transition: transform 0.3s ease-in-out;
}
.menu-text:hover .icon-box {
  transform: rotate(180deg);
}
</style>
